import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const AntStyleSwitch = styled(Switch)(({ theme }) => ({
  width: 34,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 17,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(11px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#555555',
        ...theme.applyStyles('dark', {
          backgroundColor: '#555555',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#d3d3d3',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: '#d3d3d3',
    }),
  },
}));
